import { SaveButton } from '@photosi/rn-components/headers/components/save-button/SaveButton';
import { Header } from '../../../../headers/header/Header';
import { PrivacyPolicyCtaMobile } from '@photosi/rn-components/privacy-policy-cta/PrivacyPolicyCtaMobile';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { TestIDs } from 'src/constants/testIDs.constants';
import { headerEditorTestID } from 'src/helpers/testIDs.helper';

const LeftElement = () => {
  return (
    <>
      <PrivacyPolicyCtaMobile />
      <SaveButton focusId={headerEditorTestID(TestIDs.SAVE)} focusOrder={2} focusGroup={FocusGroups.HEADER} />
    </>
  );
};
export const PreviewHeaderMobile = () => {
  return <Header leftElement={<LeftElement />} />;
};
